/**
 * Utility class for handling client-side authentication.
 */
import { config } from '../ApplicationConfig/msal';
import {AuthError} from '@azure/msal-browser';

export class Auth {

    static logout () {
        
        window.sessionStorage.clear();
        window.localStorage.clear();
    }
    
    /**
     * Identical to `window.fetch()`, except it handles token authentication
     * and refresh for you.
     */
    static async authorizedFetch (info: RequestInfo, init: RequestInit,msalInstance=null) {
        
        if (process.env.ByPassSilentToken=="true"){
            return this.executeRequest(info,init,localStorage.getItem("tokenScan")) 
        }

        const activeAccount=msalInstance.getActiveAccount();
        
        let errorToken=false
        let accessToken=''
        if (activeAccount){
 
            const silentRequest={
                account: activeAccount,
                scopes:[config.msal.TOKEN_DEFAULT_SCOPE]
            }
            await msalInstance.acquireTokenSilent(silentRequest).then((response)=>{
                
                accessToken=response.accessToken;
            })
            .catch(async (error)=>{

                if (error instanceof AuthError){
                    const loginRequest={

                        scopes:[config.msal.TOKEN_DEFAULT_SCOPE]
                    }
                    await msalInstance.acquireTokenPopup(loginRequest)
                    .then((accessTokenResponse)=>{
                        accessToken=accessTokenResponse.accessToken
                    })
                    .catch((accessError)=>{
                        console.log(accessError);
                    })
                }

            
            })
        }

        if(accessToken){
           
            
            return this.executeRequest(info,init,accessToken)
        }
        else
        {
         
            //if we reach that point then no token could be retrieve. We log out the user and refresh the page which should prompt login screen
            Auth.logout()
            window.location.reload()

        }
        
        
    }


    static executeRequest(info: RequestInfo, init: RequestInit = {},token){
        
        const headers = new Headers(init.headers);
        headers.set('Authorization', `Bearer ${token}`);

        const controller = new AbortController();
        const timeoutId = setTimeout(()=> controller.abort(), 40000);

        return fetch(info, {
            ...init,
            headers: headers,
            signal: controller.signal
        })
        .then((response)=>{
            clearTimeout(timeoutId);
            if (response.redirected) {
                let prom = response.json();
                prom.then((data)=> window.location.replace(data.redirectUrl));
            }
            return response;
        });

    }

}